<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Customer Personal Details</h3>
  </div>
  <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent()" style="color: white; background: red;">CLOSE</button>
  </div>
</div><br>
<form [formGroup]="person_detail">
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>First Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" formControlName='first_name'>
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label>Last Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control code_box" formControlName='last_name'>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>Mobile<i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="number" class="form-control code_box" formControlName='mobile'>
      </div>
      <div style="font-style: italic; font-size: small"
        [ngStyle]="{'color': person_detail.controls.mobile.valid? 'green': 'red'}"
        *ngIf="person_detail.controls.mobile.errors !== null">
        {{ person_detail.controls.mobile.errors['error']}}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" style="text-align: center;">
      <button (click)="updateCalled()" mat-raised-button class="button-class" [disabled]="!person_detail.valid">Update</button>
    </div>
  </div>
</form>
